import QuestionAnswerComponent, {Question} from "../help/QuestionAnswerComponent.tsx";
import {Link} from "react-router-dom";
import Routing from "../../Routing.ts";

const questions: Question[] = [
    {
        question: 'Skal jeg selv opsige min nuværende bredbåndsaftale hos en anden udbyder?',
        answer: <>
            <p>
                Vi kan opsige dit nuværende abonnement for dig.
                Når du bestiller hos os, kan du udfylde en fuldmagt, der giver os lov til at opsige abonnementet for dig.
            </p>
            <p>
                Hvis du ikke udfylder fuldmagten i forbindelse med bestillingen, får du også en mail med mere information.
            </p>
        </>,
    },
    {
        question: 'Kan jeg ændre min hastighed?',
        answer: <p>
            Du kan altid opgradere din hastighed, ved at <Link to={Routing.Contact.Index}>kontakte vores kundeservice</Link>.
        </p>,
    },
    {
        question: 'Hvor lang er min bindingsperiode?',
        answer: <p>
            Der er 6 måneders binding på dit Hiper Bredbånd, som gælder fra leveringsdatoen.
            Hvis du vælger at opsige dit abonnement, får du en bekræftelse i en mail, hvor du kan se den præcise slutdato for abonnementet, og hvordan du skal returnere det fremsendte udstyr.
        </p>,
    },
    {
        question: 'Skal jeg have tekniker på besøg?',
        answer: <>
            <p>
                Når du indtaster din adresse, og vælger et fiberprodukt, kan du se om du skal have en tekniker på besøg.
            </p>
            <p>
                Det afhænger nemlig af din fiberinstallation &ndash;
                nogle gange mangler der en fiberboks, og andre gange skal den eksisterende skiftes, og det kan du tjekke, når du indtaster din adresse.
            </p>
            <p>
                Læs mere om <Link to="/hjaelp/bestilling/fiber-installation">installation</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg bruge mit eget udstyr?',
        answer: <>
            <p>
                Ja, du er altid velkommen til at bruge dit eget udstyr.
            </p>
            <p>
                Læs mere <Link to="/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr">her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg få en fast IP?',
        answer: <>
            <p>
                Du kan få en fast IP-adresse til 19 kr./md. eller en gratis dynamisk IP-adresse.
            </p>
            <p>
                Læs mere <Link to="/hjaelp/internet-og-wifi/ip-adresse">her</Link>.
            </p>
        </>,
    },
]

export default function WorthToKnowSectionComponent() {
    return (
        <section className="section-white">
            <div className="content content--narrow">
                <div className="blurb">
                    <h3 className="heading heading--big">Værd at vide inden du bestiller</h3>
                </div>
                <QuestionAnswerComponent questions={questions}/>
            </div>
        </section>
    )
}
